module.exports = __webpack_public_path__ + "static/box0-de6f0bd4728e1a7e1009106c2a368904.jpg";